__turbopack_context__.v({
  "active": "p-Q6ZW_active",
  "tabButton": "p-Q6ZW_tabButton",
  "tabContent": "p-Q6ZW_tabContent",
  "tabHeaders": "p-Q6ZW_tabHeaders",
  "tabsWrapper": "p-Q6ZW_tabsWrapper",
});
